import { render } from "./LinkContact.vue?vue&type=template&id=53763e98&scoped=true"
import script from "./LinkContact.vue?vue&type=script&lang=js"
export * from "./LinkContact.vue?vue&type=script&lang=js"

import "./LinkContact.vue?vue&type=style&index=0&id=53763e98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53763e98"]])

export default __exports__